import './App.css';

import { BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';
import { useEffect, useContext } from 'react';
import { css } from '@emotion/css';

//helpers
// import Aux from "./hoc/AuxComponent/AuxComponent";

// Pages
import Welcome from './containers/Welcome/Welcome';
import PokemonList from './containers/PokemonList/PokemonList';
import PokemonDetail from './containers/PokemonDetail/PokemonDetail';
import MyPokemon from './containers/MyPokemon/MyPokemon';


//compoments
import NavigationItems from './components/Navigation/NavigationItems/NavigationItems';
import PokemonSplash from './components/PokemonSplash/PokemonSplash';
import LoadingError from './components/LoadingError/LoadingError';

import pokemonlogo from './image/pokemonlogo.svg';

//Context
import MySavedDataContext from './store/MySavedData-context';

import { ApolloProvider, ApolloClient, InMemoryCache } from "@apollo/client";

const client = new ApolloClient({
  uri: 'https://graphql-pokeapi.vercel.app/api/graphql',
  cache: new InMemoryCache()
})

function App() {

  const ctx = useContext(MySavedDataContext);




  // const loadData = () => {
  //   //Load storage to State
  //   setMySavedData(JSON.parse(localStorage.getItem("myLocalStorageSavedData")));
  // }

  // const clearSavedData = () => {
  //   localStorage.clear();

  //   console.log('You just cleared your save data.. it should be clear like this:');
  //   console.log(JSON.parse(localStorage.getItem("myLocalStorageSavedData")));
  // }


  // //My SavedData Effect
  // useEffect(() => {
  //   console.log('------------------------mySavedData effect! state changed! status:');

  //   saveData();

  //   console.log('Current mySavedData State: ');

  //   console.log(mySavedData);

  //   console.log('Current LOCAL STORAGE: ');

  //   console.log(localStorage.getItem("myLocalStorageSavedData"));
  //   console.log('------------------------');
  //   //check what kind of update is happening
  // }, [mySavedData]);


  // let isInitialLoad = true;

  //Component did mount
  // useEffect(() => {
  //   console.log('Component did mount, trying to load your previous data...');

  //   if(isInitialLoad){
  //     if (localStorage.getItem("myLocalStorageSavedData") !== null) { //watch out for SSR trying to check localstorage...
  //       //save data found, autoloading...
  //       console.log('SAVE DATA FOUND');
  //         ctx.loadData();
  //         console.log('autoloading save data to state....');
  //     } else {
  //       //no save data exist yet...
  //       console.log('NO SAVE DATA FOUND');
  //       console.log(localStorage.getItem("myLocalStorageSavedData"));
  //     }

  //     isInitialLoad = false;
  //   }

  //   console.log('Component Did mount completed');

  //   // return () => {
  //   //   console.log('use Effect component unmounted');
  //   // }
  // }, []);

  // Component did mount
  useEffect(() => {
    //preloading image of pokemon logo
    const img = new Image();
    img.src = pokemonlogo;

    setTimeout(() => {
      if (!("Notification" in window)) {
        console.log("This browser does not support desktop notification");
      } else {
        Notification.requestPermission();
        //MAKE SURE DO NOT DISTRURB IS TURNED OFF!
      }
    }, 5000);

  }, []);

  const showNotification = (message) => {
    new Notification(message);
  }


  const Page404 = () => (<LoadingError />);

  // const createScheduledNotification = async (tag, title, timestamp) => {
  //   const registration = await navigator.serviceWorker.getRegistration();
  //   registration.showNotification(title, {
  //     tag: tag,
  //     body: 'This notification was scheduled 30 seconds ago',
  //     showTrigger: new TimestampTrigger(timestamp + 30 * 1000),
  //   });
  // };

  return (
    <ApolloProvider client={client}>
      <BrowserRouter>
        <div className="App">

          <NavigationItems />

          <PokemonSplash />

          {/* Cheat bar: debug only */}
          {/* <button onClick={() => { ctx.saveData(ctx.mySavedData) }}>Set Data</button>
          <button onClick={() => { ctx.loadData() }}>Get Data</button>
          <button onClick={() => { ctx.clearSavedData() }}>CLEAR SAVED DATA! warning!</button>
          */}
          {/* 
          <button onClick={showNotification}>
            Click to show notification
          </button> */}

          <div className="container">
            <Switch>
              <Route path="/pokemonlist" render={(props) => <PokemonList {...props} mySavedData={ctx.mySavedData} />} />
              <Route path="/mypokemon" render={(props) => <MyPokemon {...props} mySavedData={ctx.mySavedData} setMySavedData={ctx.setMySavedData} />} />
              <Route path="/pokemondetail/:paramsPokemonID" render={(props) => <PokemonDetail {...props} mySavedData={ctx.mySavedData} setMySavedData={ctx.setMySavedData} currentTime={ctx.currentTime} showNotification={showNotification} />} />
              <Route path="/" exact component={Welcome} />
              <Route component={Page404} />
            </Switch>
          </div>

          <div className={css`
          margin-bottom:100px;
          `}>

          </div>
        </div>
      </BrowserRouter>
    </ApolloProvider>
  );
}

export default App;
